import * as React from 'react';
import { useAnimate, motion } from 'framer-motion';
import { observer } from 'mobx-react';

import { useUiStore } from 'stores';
import { MENU_CLOSED_WIDTH, MENU_OPENED_WIDTH } from 'stores/uiStore';

import Header from '../Header';
import Menu from '../Menu';

import './Left.modules.scss';

const Left: React.FC = () => {
  const uiStore = useUiStore();
  const [ref, animate] = useAnimate();

  React.useEffect(() => {
    if (!ref.current) {
      return;
    }

    const targetWidth = uiStore.menuState.opened
      ? MENU_OPENED_WIDTH
      : MENU_CLOSED_WIDTH;

    animate(ref.current, { width: targetWidth });
  }, [uiStore.menuState.opened]);

  const handleNavigationState = () => {
    uiStore.changeMenuOpened(!uiStore.menuState.opened);
  };

  const variants = {
    opened: { width: MENU_OPENED_WIDTH },
    closed: { width: MENU_CLOSED_WIDTH }
  };

  return (
    <motion.div
      initial={uiStore.menuState.opened ? 'opened' : 'closed'}
      variants={variants}
      ref={ref}
      styleName="left"
    >
      <Header onBurgerClick={handleNavigationState} styleName="left__header" />
      <Menu styleName="left__content" />
    </motion.div>
  );
};

export default observer(Left);
